export const PostalCode = 'postal_code'
export const StateOrPrefecture = 'state'
export const City = 'city'
export const Street = 'town'
export const Building = 'address'
